export default __webpack_public_path__ + "static/media/apthenalscreen-main.c43ce3ac.png";